<script>
  import { onMount, onDestroy } from "svelte";
  import { ignore } from "./tools.js";
  import {External} from "../external";

  export let color = "#ffffff",
    colorClass = "",
    label = "",
    description = "",
    clz = "",
    onChange = ignore,
    alpha = "yes";

  let input, ui, colorpicker;

  onMount(function () {
    input = External.$(input);
    ui = External.$(ui);
    colorpicker = null;

    let initialColor = External.GlobalStyling.getColorFromClass(colorClass || "", color || "");

    colorpicker = External.Tools.addColorPicker(initialColor, ui, input, (selectedColor, selectedColorClass) => {
      color = alpha !== "no" ? selectedColor : External.Tools.rgbaToHexNoAlpha(selectedColor);
      colorClass = selectedColorClass;
      onChange(color, colorClass);
    });
  });

  onDestroy(function () {
    External.Tools.removeColorPicker(colorpicker);
  });

  export function get() {
    return {
      color: color,
      colorClass: colorClass
    };
  }
</script>

<div class="color-pick-wrap {clz}">
  <div bind:this={ui}></div>
  <input type="text" class="colorpicker-selected" bind:this={input} />
</div>
<div class="info">
  <h5>{label}</h5>
  {#if description}
    <span>{description}</span>
  {/if}
</div>
